import angular from 'angular';
import {guard} from '@acng/frontend-rubicon';
import {popup} from '@acng/frontend-discovery';
// @ts-ignore
import pick from 'underscore/modules/pick.js';

import {getLocale} from 'acng/locale/model/locale.js';
import {publish} from '../context/event-bus.js';
import {setOutdated} from '../service/backend/x-version.js';
import {showTurnstyle} from '../service/backend/cf-challenge.js';
import {X_USERPOPUPS} from '../service/backend/x-userpopups.js';
import {setPopups} from '../../userPool/service/director.js';
import {Auth} from '../../user/auth/auth.js';
import {make, VERSION} from '../service/env.js';
import {user} from '../../user/user.js';

angular.module('core').factory('globalHttpInterceptor', [
  '$q',
  '$injector',
  /**
   * @param {angular.IQService} $q
   * @param {angular.auto.IInjectorService} $injector
   * @returns {angular.IHttpInterceptor}
   */
  function ($q, $injector) {
    return {
      request: function (config) {
        if (/^\/?api(.*)/.exec(config.url)) {
          (config.params || (config.params = {})).locale = getLocale();
        }
        //config.headers = {...config.headers, 'X-Version': VERSION};
        return config;
      },
      response: function (response) {
        var messages = angular.fromJson(response.headers()['x-notifications'] || '[]');

        angular.forEach(messages, function (message) {
          // message.type: "danger" | "warning" | "info" | "success"
          // @ts-ignore
          popup()[{danger: 'error', warning: 'warn', info: 'info', success: 'info'}[message.type]](
            message.message
          );
        });

        if (response.headers('x-version') && response.headers('x-version') != VERSION) {
          setOutdated();
        }

        if (response.headers('x-userpopups')) {
          const popups = angular.fromJson(response.headers('x-userpopups') || '[]');
          ASSERT: guard(popups, X_USERPOPUPS);
          setPopups(popups);
        }

        return response;
      },
      responseError: function (rejection) {
        if (rejection.headers('cf-mitigated') === 'challenge') {
          showTurnstyle();
        }

        if (!(rejection.config && rejection.config.dontIntercept)) {
          switch (rejection.status) {
            case 401:
              if (!user.guestSignup(rejection.config && rejection.config.signupOverlayParams)) {
                return make(Auth).kick();
              }
              break;
            case 402: // use event or something
              if (rejection.data && rejection.data.code == 4001) {
                if ($injector.has('Payback')) {
                  $injector.get('Payback').openOverlay();
                  break;
                }
              } else if ($injector.has('payment')) {
                angular.element(document).focus();
                $injector.get('payment').overlay(rejection.config && rejection.config.paymentOverlayParams);
                break;
              }
            case 409:
              if (rejection.data.code < 9000 || rejection.data.code > 9999) {
                break;
              }

              let id = [9000, 9003].includes(rejection.data.code)
                ? rejection.config.data.recipient
                : /^.*\/(\d+)$/.exec(rejection.config.url)?.[1];
              /** @type {{9000: "msg", 9001: "movie", 9002: "picture", 9003: "msg"}} */
              let type = {9000: 'msg', 9001: 'movie', 9002: 'picture', 9003: 'msg'};

              /**
               * @type {Valid<typeof import('../model/price-change').EVENTBUS_PRICE_CHANGE>}
               */
              const busEvent = {
                type: 'price',
                article: {
                  article_id: id,
                  newPrice: Number(rejection.data.price),
                  // @ts-ignore
                  type: type[rejection.data.code],
                },
              };

              publish(busEvent);

              if (rejection.config.data.price > rejection.data.price && rejection.config.method != 'GET') {
                return $injector.get('http')()[rejection.config.method.toLowerCase()](
                  rejection.config.url,
                  {...rejection.config.data, price: rejection.data.price},
                  {
                    // @ts-ignore
                    headers: pick(rejection.config.headers, (value, key) => {
                      return key.indexOf('X-') === 0 || key == 'Content-Type';
                    }),
                    paymentOverlayParams: rejection.config.paymentOverlayParams,
                  }
                );
              }
              break;
            default:
              if (
                (!rejection.config || !rejection.config.noMessageBag) &&
                rejection.data &&
                rejection.data.message &&
                rejection.data.code != 3002
              ) {
                popup().error(rejection.data.message);
              }
          }
        }
        return $q.reject(rejection);
      },
    };
  },
]);
